import { CommonModule, DatePipe } from '@angular/common';
import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  Optional,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { FormErrorsComponent } from 'src/app/components/form-errors/form-errors.component';
import { Carousels } from 'src/app/models/carousels/carousels';
import { CarouselsService } from 'src/app/services/carousels.service';
import { FileStorageService } from 'src/app/services/file-storage.service';

@Component({
  selector: 'app-carousels-modal',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormErrorsComponent,
    MatDialogContent,
    MatDialogActions,
    MatDialogTitle,
  ],
  templateUrl: './carousels-modal.component.html',
  styleUrls: ['./carousels-modal.component.css'],
})
export class CarouselsModalComponent implements OnInit {
  form: FormGroup = new FormGroup({});
  photoPreview: string | null = null;
  selectedFile: File | null = null; // Para manejo local del archivo

  constructor(
    private fb: FormBuilder,
    public datePipe: DatePipe,
    public dialogRef: MatDialogRef<CarouselsModalComponent>,
    public CarouselsService: CarouselsService,
    public _toastService: ToastrService,
    private fileStorage: FileStorageService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.buildForm();

    if (this.data?.item) {
      this.form.patchValue({ ...this.data?.item });
    }
    if (this.data?.view) {
      this.form.disable();
    }
    if (this.data?.item?.file) {
      this.photoPreview = this.data?.item?.file;
    }
  }

  ngOnInit(): void {}

  private buildForm() {
    this.form = this.fb.group({
      id: new FormControl(0),
      startDate: new FormControl(null, [Validators.required]),
      endDate: new FormControl(null, [Validators.required]),
      fileId: new FormControl(0, [Validators.required, Validators.min(1)]),
      fileFoto: new FormControl(null),
      isEnabled: new FormControl(true),
    });
  }

  Accept() {
    const CarouselsModel = this.form?.value as Carousels;

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this._toastService.error(
        'Por favor, complete todos los campos requeridos.'
      );
      return;
    }

    if (this.data.mode == 'add' || this.data.mode == 'edit') {
      this.save(CarouselsModel);
    } else if (this.data.mode == 'delete') {
      this.delete(CarouselsModel.id);
    }
  }
  async save(CarouselsModel: Carousels) {
    // Si hay un archivo seleccionado, subirlo primero
    if (this.selectedFile) {
      try {
        const uploadResponse = await this.fileStorage
          .uploadFile(this.selectedFile)
          .toPromise();
        if (uploadResponse && uploadResponse.fileId) {
          this.form.patchValue({ fileId: uploadResponse.fileId });
          // Actualizar el modelo con el valor del formulario
          CarouselsModel = this.form.value as Carousels;
        }
      } catch (error) {
        this._toastService.error('Error al subir la imagen');
        return;
      }
    }

    this.CarouselsService.addCarousels(CarouselsModel).subscribe({
      next: (res: any) => {
        if (!res) {
          this._toastService.error('Ha ocurrido un error inesperado');
          return;
        }
        this._toastService.success('Datos guardados');
        this.closeDialog();
      },
      error: (error: any) => {
        this._toastService.error('Ha ocurrido un error inesperado');
      },
    });
  }
  delete(id: number) {
    this.CarouselsService.deleteCarousels(id).subscribe({
      next: (res: any) => {
        if (!res) {
          this._toastService.error('Ha ocurrido un error inesperado');
          return;
        }
        this._toastService.success('Datos eliminados correctamente!');
        this.closeDialog();
      },
      error: (error: any) => {
        this._toastService.error('Ha ocurrido un error inesperado');
      },
    });
  }

  closeDialog(result: boolean = true): void {
    this.dialogRef.close(result);
  }

  uploadFoto() {
    document.getElementById('fileFoto')?.click();
  }

  onPhotoSelected(event: any) {
    const file = event.target.files[0];
    if (!file) return;
    if (!this.validatePhotoFileType(file)) {
      this._toastService.warning(
        'Archivo inválido',
        'Solo se permiten imágenes JPG o PNG'
      );
      return;
    }

    // Guardar archivo localmente
    this.selectedFile = file;

    // Previsualizar
    const reader = new FileReader();
    reader.onload = () => {
      this.photoPreview = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  removePhoto() {
    this.selectedFile = null;
    this.photoPreview = null;
    this.form.patchValue({ fileId: 0 });
  }

  // Cambiar el método de validación para solo imágenes
  validatePhotoFileType(file: File): boolean {
    const allowedPhotoTypes = ['image/png', 'image/jpeg', 'image/jpg'];
    return allowedPhotoTypes.includes(file.type);
  }
}
